import React, { Component } from 'react';
import { base, firebaseAuth, algoliaKey, alogoliaAccount, logComponentLoad, logDashboardAction} from '../../../config/constants';
import { Grid } from 'semantic-ui-react'
import * as UiConsts from '../../../config/UiConstants'
import OrderCard from '../../dashBoard/newDashboard/OrderCard';
import * as algoliasearch from 'algoliasearch';
import { getPrintValues, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { Table, Form, Segment, Button, Divider, } from 'semantic-ui-react';


class SingleOrderViewArchives extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            imageUrl: '',
            orderNumber: '',
            loadingUser: true,
            loading: false,
            orderFound: '',
            order: [],
            deliveryPeople: [],
            orderNotFound: false,
            status: '',
            designers: [],
            phone: '',
            order_num: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("soarch1 user is signed in:" + user.email);

                if (user.email) {
                    console.log("soarch01 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    checkAdminEmail(user.email, this.setAdminResult);

                    this.setState({
                        user: user,
                        loadingUser: false,
                    })
    
                    // this.loadOrders(this.props.match.params.order_num);

                }

            } else {
                console.log("user is NOT signed in:" + user.uid);
            }

            this.setState({
                loadingUser: false
            })
        });

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ soarch13 setAdminResult");
        console.log("soarch14 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "SingleOrderViewArchives");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser:false
        })

        if(returnObject.isAdmin){

            this.loadOrders(this.props.match.params.order_num);

            this.loadDesigners();
            getPrintValues("statuses", this.loadStatuses);
            getPrintValues("adminemail", this.loadAdmins);
            
        }
    }


    loadStatuses = (statuses) => {
        // console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ orderStatuses: statuses })
    }

    loadAdmins = (statuses) => {
       // console.log("addx12 ++++++ admins ");
       // console.log("addx121 admins:" + JSON.stringify(statuses, null, 3));
        this.setState({ admins: statuses })
    }

    loadDesigners = () => {
        //console.log("aglx922:-----: loadDesigners calling getDesigners");


        var client = algoliasearch(alogoliaAccount, algoliaKey);
        var index = client.initIndex('printb_values');

        index.search({
            query: '',
            //  facetQuery: '',
            filters: 'grouping:design'
        }).then(content => {
           // console.log("aglx91:" + JSON.stringify(content.hits, null, 3));

            this.setState({
                designers: content.hits
            });


        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);

        });
    }

    loadOrdersByOrderNum = () => {
        console.log("+++++++: load loadOrdersByOrderNum");
        console.log("order_num:" + this.state.order_num);

        this.setState({
            loading: true,
            //status: order_num
        })

        logDashboardAction(this.state.user.email+" searched for "+this.state.order_num+" in archives", this.state.user.email, this.state.order_num,"SingleOrderViewArchives");

        //SNYC ORDER
        // base.syncState('archives', {
        //     context: this,
        //     asArray: true,
        //     state: 'order',
        //     queries: {
        //         orderByChild: 'order_num',
        //         equalTo: parseInt(this.state.order_num),
        //         // orderByChild: 'phone',
        //         // equalTo: order_num,
        //         limitToLast: 10
        //     },
        //     then(data) {
        //         console.log("dancing done:" + JSON.stringify(this.state.order, null, 2));
        //         this.setState({
        //             loading: false
        //         })
        //     }
        // });

        base.fetch('archives', {
            context: this,
            asArray: true,
            state: 'order',
            queries: {
                orderByChild: 'order_num',
                equalTo: parseInt(this.state.order_num),
                limitToLast: 10
            },
            then(data) {
                //  console.log(data);
                this.setState({
                    order: data,
                    loading: false
                })
            }
        });
        //parseInt(this.state.orderNumber)
    }

    loadOrdersByPhoneNumber = () => {
        console.log("+++++++: load loadOrdersByPhoneNumber");
        console.log("phone:" + this.state.phone);

        this.setState({
            loading: true,
            //status: order_num
        })

        logDashboardAction(this.state.user.email+" searched for "+this.state.phone+" in archives", this.state.user.email, null,"SingleOrderViewArchives");

        //SNYC ORDER
        // base.syncState('archives', {
        //     context: this,
        //     asArray: true,
        //     state: 'order',
        //     queries: {
        //         // orderByChild: 'order_num',
        //         // equalTo: parseInt(order_num),
        //         orderByChild: 'phone',
        //         equalTo: this.state.phone,
        //         limitToLast: 10
        //     },
        //     then(data) {
        //         console.log("dancing done:" + JSON.stringify(this.state.order, null, 2));
        //         this.setState({
        //             loading: false
        //         })
        //     }
        // });

        base.fetch('archives', {
            context: this,
            asArray: true,
            state: 'order',
            queries: {
                orderByChild: 'phone',
                equalTo: this.state.phone,
                limitToLast: 10
            },
            then(data) {
                //  console.log(data);
                this.setState({
                    order: data,
                    loading: false
                })
            }
        });
   
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        // console.log("hx32 e.target.name:" + e.target.name);
        // console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    render() {

        const orderUI = this.state.order.map((order) =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    user={this.state.user}
                    order={order}
                    deliveryPeople={this.state.deliveryPeople}
                    designers={this.state.designers}
                    orderStatuses={this.state.orderStatuses}
                    fromArchives={true} />

            </Grid.Column>
        )

        const loadingImage = this.state.loading === true
            ? <UiConsts.LoadingComponent />
            : <div>
                <Grid stackable columns={3}>
                    {orderUI}
                </Grid>

            </div>

        const phoneButton = this.state.phone.length === 10
            ? <Button onClick={this.loadOrdersByPhoneNumber}>SEARCH BY PHONE NUMBER</Button>
            : ''

        const order_numButton = this.state.order_num.length > 3
            ? <Button onClick={this.loadOrdersByOrderNum}>SEARCH BY ORDER NUMBER</Button>
            : ''

        const mainForm = this.state.loading === true
            ? <UiConsts.LoadingComponent />
            : <div>
                <Segment>
                    {/* <Form > */}
                        <Form.Field>
                            <Form.Input
                                name={'phone'}
                                value={this.state.phone}
                                placeholder='Phone Number'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>
                        {phoneButton}

                        <Divider horizontal>{'========== OR ==============='}</Divider>
                        <Form.Field>
                            <Form.Input
                                name={'order_num'}
                                value={this.state.order_num}
                                placeholder='Order Number'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>
                        {order_numButton}

                    {/* </Form> */}
                </Segment>
            </div>

        //const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.isAdmin
        const wholeUI = this.state.algoliaUser 
            ? <div>
                <h1>SEARCH ARCHIVES (BE PATIENT IT TAKES A WHILE)</h1>
                <h1>NUM ORDERS - {this.state.order.length}</h1>
                <br />

                {mainForm}

                {loadingImage}
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loadingUser === true ? <UiConsts.LoadingComponent /> :
            <div>
                
                <h1>SEARCH ARCHIVES (BE PATIENT IT TAKES A WHILE)</h1>
                <h1>NUM ORDERS - {this.state.order.length}</h1>
                <br />

                {mainForm}

                {loadingImage}

            </div>
        )
    }
}

export default SingleOrderViewArchives;


// WEBPACK FOOTER //
// ./src/components/newSite/SingleOrderView/SingleOrderViewArchives.js